import React, { useState } from "react";
import "./App.css";
import DrawingBoard from "./DrawingBoard";
import FourierTransform from "./FourierTransform";
import InverseFourierTransform from "./InverseFourierTransform";

function App() {
  const [points, setPoints] = useState({});
  const [selectedTransform, setSelectedTransform] = useState("FourierTransform");
  const width = 600;
  const height = 400;

  return (
    <div className="App">
      <div className="transform-selection">
        <select
          value={selectedTransform}
          onChange={(e) => setSelectedTransform(e.target.value)}
        >
          <option value="FourierTransform">Fourier Transform</option>
          <option value="InverseFourierTransform">Inverse Fourier Transform</option>
        </select>
      </div>
      <div className="drawing-board-container">
        <DrawingBoard onPointsChange={setPoints} width={width} height={height} />
      </div>

      <div className="fourier-transform-container">
        {selectedTransform === "FourierTransform" ? (
          <FourierTransform points={points} width={width} height={height} />
        ) : (
          <InverseFourierTransform points={points} width={width} height={height} />
        )}
      </div>
    </div>
  );
}

export default App;
